// extracted by mini-css-extract-plugin
export var activeFilterButton = "_jo-c";
export var backButton = "_jo-4";
export var backIcon = "_jo-5";
export var chevronShortcut = "_jo-6";
export var container = "_jo-1";
export var editor = "_jo-8";
export var editorWrapper = "_jo-7";
export var prefix = "_jo-2";
export var searchIcon = "_jo-3";
export var suffix = "_jo-9";
export var suffixContent = "_jo-a";
export var suffixText = "_jo-b";
export var wrapper = "_jo-0";